import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[750px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20night%20sky%20with%20dramatic%20star%20trails%20and%20distant%20city%20lights%20on%20horizon%2C%20atmospheric%20nocturnal%20landscape%2C%20deep%20indigo%20and%20charcoal%20tones%20with%20warm%20amber%20light%20streaks%2C%20cinematic%20night%20photography%2C%20vast%20open%20sky%2C%20moody%20and%20powerful%20composition&width=1800&height=1000&seq=hero-bg-night&orientation=landscape"
          alt="夜无疆 - 打破黑夜边界的极致体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-background-950"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 text-primary-400 text-sm">
            <i className="ri-moon-clear-line"></i>
            <span>探索夜晚的无限可能</span>
          </span>
        </div>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-50 leading-tight mb-6">
          打破黑夜边界
          <br />
          <span className="text-primary-400">感受夜的</span>
          <span className="text-accent-400">自由与力量</span>
        </h1>
        <p className="text-foreground-400 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          无论是夜间生活、创作灵感还是深夜情绪，夜无疆陪你穿越每一个漫长黑夜，
          让夜晚不再有边界，探索属于夜的自由国度。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/night-life"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-lg transition-all duration-300 text-base whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-800/60 hover:bg-background-700/80 text-foreground-200 border border-background-600/50 font-medium rounded-lg transition-all duration-300 text-base whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-foreground-600 text-xs">向下滚动</span>
        <div className="w-5 h-8 rounded-full border border-foreground-600/50 flex items-start justify-center p-1">
          <div className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}